
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue4 as ObiWindTrue4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-4.js';
 
 
 

 
 export const ObiWindTrue4 = createComponent({
   react: React,
   tagName: 'obi-wind-true-4',
   elementClass: ObiWindTrue4Element,
   events: {
     
   }
  });
 
 